<script>
import Layout from '@layouts/loginLayout.vue'
import { loadResetSecurityQuestionForm, submitResetSecurityQuestionForm } from '@src/api/auth'
import _ from 'lodash'

export default {
  page: {
    title: 'Reset Security Question',
    meta: [
      {
        name: 'description',
        content: 'The Reset Security Question page.',
      },
    ],
  },
  components: { Layout },
  data() {
    return {
      recoveryQuestions: '',
      oktaId: '',
      userEmail: '',
      recoveryQuestion: '',
      recoveryAnswer: '',
      initialLoading: true,
      loading: false,
      successfully: false,
    }
  },
  computed: {
    labels() {
      return {
        recoveryQuestion: 'New Security Question',
        recoveryAnswer: 'New Security Answer',
      }
    },

    placeholders() {
      return {
        recoveryAnswer: 'Answer',
      }
    },

    canPressButton() {
      if (!this.recoveryAnswer || !this.recoveryQuestion) {
        return false
      }

      return !this.loading
    },
  },
  created() {
    this.loadResetSecurityQuestionForm()
  },
  methods: {
    async loadResetSecurityQuestionForm() {
      this.authError = null
      try {
        await loadResetSecurityQuestionForm({
          token: this.$route.query.token,
        }).then((result) => {
          this.recoveryQuestions = result.data.data.questions
          this.oktaId = result.data.data.oktaId
          this.userEmail = result.data.data.userEmail
          this.initialLoading = false
        })
      } catch (err) {
        this.initialLoading = false
        this.toastLinkError()
      }
    },

    async submitResetSecurityQuestionForm() {
      this.authError = null
      this.loading = true
      try {
        await submitResetSecurityQuestionForm({
          oktaId: this.oktaId,
          recoveryQuestion: this.recoveryQuestion,
          recoveryAnswer: this.recoveryAnswer,
        }).then(() => {
          this.toastSuccess()
        })
      } catch (err) {
        const response = _.get(err, 'response.data.data', 'Server Error. Please try again in a few moments.')
        this.authError = response

        if (typeof response === 'object') {
          this.authError = _.values(response)[0]
        }
        this.toastError()
        this.loading = false
      }
    },

    toastError() {
      this.$bvToast.toast(this.authError, {
        toaster: 'b-toaster-bottom-center',
        toastClass: 'toast-error',
      })
    },

    toastLinkError() {
      const toastMessage = 'Your reset security question link has expired. Please contact support.'
      this.$bvToast.toast(toastMessage, {
        toaster: 'b-toaster-bottom-center',
        toastClass: 'toast-error',
        noAutoHide: true,
      })
      this.loading = false
      this.successfully = true
    },

    toastSuccess() {
      const toastMessage = 'You have successfully reset your security question!'
      this.$bvToast.toast(toastMessage, {
        toaster: 'b-toaster-bottom-center',
        toastClass: 'toast-success',
        noAutoHide: true,
      })
      this.loading = false
      this.successfully = true
    },
  },
}
</script>

<template>
  <Layout>
    <form @submit.prevent="submitResetSecurityQuestionForm">
      <h1 class="motto-blue-text mb-20">Reset Security Question</h1>

      <h3 class="motto-blue-text mb-45">{{ userEmail }}</h3>

      <BaseIcon v-if="initialLoading" name="spinner" spin />

      <div v-else-if="!successfully">
        <BaseFormGroup :label="labels.recoveryQuestion" class="mb-40">
          <BaseSelect
            v-model="recoveryQuestion"
            name="recoveryQuestion"
            empty-text="-- Select a Security Question --"
            :options="recoveryQuestions"
            option-text="questionText"
            option-value="questionText" />
        </BaseFormGroup>

        <BaseFormGroup :label="labels.recoveryAnswer" class="mb-55">
          <BaseInputText
            v-model="recoveryAnswer"
            autocomplete="off"
            name="recoveryAnswer"
            :placeholder="placeholders.recoveryAnswer" />
        </BaseFormGroup>

        <BaseButton :disabled="!canPressButton" type="submit">
          <BaseIcon v-if="loading" name="spinner" spin />
          <span v-else>Reset Security Question</span>
        </BaseButton>
      </div>

      <div v-else>
        <BaseLink :to="{ name: 'login' }">
          <BaseButton type="button">
            <span>Back to Login</span>
          </BaseButton>
        </BaseLink>
      </div>
    </form>
  </Layout>
</template>
